<template>
  <v-fade-transition mode="out-in">
    <router-view />
  </v-fade-transition>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    title: "App",
    titleTemplate: "%s | AWM Telco: OTT messaging services",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: 'description', content: 'AWM Telco specializes in OTT messaging services, empowering businesses with high-quality, scalable messaging solutions for effective customer engagement. Discover our seamless OTT solutions tailored to elevate your communication strategy.' },
      { name: 'keywords', content: 'OTT messaging services, AWM Telco, business messaging solutions, over-the-top messaging, customer engagement, scalable messaging, telecom OTT services, messaging API, SMS alternatives, real-time messaging solutions' }
    ],
  },
}
</script>

<style lang="sass">
.extra-padding
  padding-bottom: 96px !important
  padding-top: 96px !important

  @media screen and (max-width: 959px)
    padding-top: 48px !important
    padding-bottom: 48px !important
</style>

